// extracted by mini-css-extract-plugin
module.exports = {"openRolesContainer":"OpenRoles_openRolesContainer__w4IvU","hrStyle":"OpenRoles_hrStyle__fJ9W2"};